import React from 'react'
import { Text } from 'components/Text'
import { ProductDetail } from 'models/Product'

type FurtherDetailsProps = {
  productDetail: ProductDetail
}

export const FurtherDetails = ({ productDetail }: FurtherDetailsProps) => {
  return (
    <>
      {productDetail.details.map((detail, index) => (
        <Text
          key={index}
          size="headline"
          color="primary-800"
          dangerouslySetInnerHTML={{ __html: detail.enUS }}
        />
      ))}
    </>
  )
}

FurtherDetails.displayName = 'FurtherDetails'
